import { render, staticRenderFns } from "./VerifyHistory.vue?vue&type=template&id=133a5834&scoped=true&"
import script from "./VerifyHistory.vue?vue&type=script&lang=js&"
export * from "./VerifyHistory.vue?vue&type=script&lang=js&"
import style0 from "./VerifyHistory.vue?vue&type=style&index=0&id=133a5834&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "133a5834",
  null
  
)

export default component.exports